import { createSlice } from '@reduxjs/toolkit'

import { TLocation } from 'types/store'

type TInitialState = {
  pagination: Record<
    TLocation,
    {
      offSet: number
      page: number
    }
  >
  user: {
    email: string
    fullName: string
    id: string
    appRole: string[]
    orgName: string
  }
}

const initialState: TInitialState = {
  pagination: {
    accounts: {
      offSet: 100,
      page: 0,
    },

    'roles-permissions': {
      offSet: 100,
      page: 0,
    },

    'pos-accounts': {
      offSet: 100,
      page: 0,
    },
  },
  user: {
    email: '',
    fullName: '',
    id: '',
    appRole: [],
    orgName: '',
  },
}

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    signIn(state, { payload }) {
      state.user = payload
    },
    updateOffset(
      state,
      { payload: { location, offSet } }: { payload: { location: TLocation; offSet: number } }
    ) {
      state.pagination[location].offSet = offSet
    },
    setPage(
      state,
      { payload: { location, page } }: { payload: { location: TLocation; page: number } }
    ) {
      state.pagination[location].page = page
    },
  },
})

export const { signIn, updateOffset, setPage } = appStateSlice.actions
export const { reducer } = appStateSlice
